import React, {Component} from "react";

import PropTypes from 'prop-types';
/*import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';<FontAwesomeIcon icon={faTimes} />*/
import { X } from 'react-feather';
import {XButton, XDiv,XI} from "../Layout/Layout";
import style from "../Style";

class  Alert extends Component{

    constructor(props) {
        super(props);
        this.itemId = props.itemId;
        this.handleCloseUp = this.closeUp.bind(this);
        this.handleProgress = this.runProgressbar.bind(this);
        this.element=React.createRef();
        this.bar=React.createRef();
        this.timeout = 10;
        this.timeleft=0;
        this.Timer=null;
        this.state = {w: 0,isInit: false};
        this.timeout = props.autoClose/10;
        if (this.timeout < 10) this.timeout = 10;
        this.props=props;
    }

    closeUp(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.animExit();
    }

    animExit() {
        style.removeClass( this.element.current,this.props.animEnter);
        style.addClass( this.element.current,this.props.animExit);
        let id1=this.itemId;
        setTimeout(function() {
            this.props.closeItem(id1);
        }.bind(this), 1000);
    }

    runProgressbar( ) {
        if(this.timeleft >= 100){
            clearInterval(this.Timer);
            this.Timer=null;
            this.animExit();
        }else {
            this.timeleft++;
            let w = this.timeleft * this.state.w;
            this.bar.current.style.width = w + "px";
        }
    };

    componentDidMount(){
        if(this.state.isInit===false) {
            if ( this.props.autoClose>0) {
                let w = this.element.current.offsetWidth;
                w = w / 100;
                this.setState({w: w, isInit: true});
                this.Timer = setInterval(this.handleProgress, this.timeout);
            }
        }
    }

    destroy() {
        if(this.Timer!==null) {
            clearInterval(this.Timer);
            this.Timer = null;
        }
    }

    componentWillUnmount() {
        this.destroy();
    }

    render() {
        const {
            type,
            className,
            children,
            hasClose,
            autoClose,
            animEnter,
        } = this.props;

        let cC="";
        if(hasClose){
            cC="alert-dismissible";
        }
        let c=`alert  alert-${type} ${className} ${cC} ${animEnter}`;

        let close;
        if (hasClose) {
            close =  <XButton  type='button' className='close' onClick={this.handleCloseUp}  >
                <X size={18} />
                </XButton>;
            c=c+" alert-has-progressbar alert-has-timeout ";
        }

        let strAutoClose;
        if (autoClose>0) {
            strAutoClose = <><XDiv className='alert-progressbar'/><XDiv className='alert-bar' eleRef={this.bar}/></>;
        }

        return (
            <React.Fragment>
                <XDiv className={c} eleRef={this.element} >
                    {close}
                    {strAutoClose}
                    {children}
                </XDiv>
            </React.Fragment>
        )
    }
}

Alert.propTypes = {
    itemId: PropTypes.number,
    type: PropTypes.oneOf(['info', 'success','warning','error','danger' ]),
    className: PropTypes.string,
    animEnter: PropTypes.string,
    animExit: PropTypes.string,
    hasClose: PropTypes.bool,
    autoClose: PropTypes.number,
    closeItem:PropTypes.func,
};

Alert.defaultProps = {
    type:"success",
    className:"",
    animEnter:"animated zoomIn",
    animExit:"animated bounceOut",
    hasClose:true,
    autoClose:1300
};

export default Alert;
